import * as Yup from 'yup';

export interface TariffDescriptionType extends Record<string, unknown> {
    description: string;
    descriptionFrench: string;
    descriptionGerman: string;
    monthlyFee: number | string;
    currency: string;
    country?: string;
    region?: string;
}

export const tariffDescriptionSchema = Yup.object().shape({
    description: Yup.string().required('schemaRequiredTariffDescription'),
    descriptionFrench: Yup.string().required('schemaRequiredTariffDescription'),
    descriptionGerman: Yup.string().required('schemaRequiredTariffDescription'),
    country: Yup.string(),
    region: Yup.string(),
    monthlyFee: Yup.number()
        .typeError('schemaRequiredMonthlyFee')
        .required('schemaRequiredMonthlyFee')
        .min(0)
        .test('max-decimals', 'schemaMaxDecimals', (value) => {
            if (value === undefined || value === null) return true;
            const decimalPart = String(value).split('.')[1];
            return !decimalPart || decimalPart.length <= 2;
        }),
    currency: Yup.string().required('schemaRequiredCurrency'),
});
